import { UserManager, UserManagerSettings } from "oidc-client-ts"
import { ClientConfig } from "@/models/ClientConfig";

let userManager: UserManager | null = null

export function getUserManager(): UserManager | null {
    return userManager
}

export function buildUserManager(config?: ClientConfig) {
    if (!config) {
        return
    }

    const port = window.location.port ? `:${window.location.port}` : ''
    const currentUri = `${window.location.protocol}//${window.location.hostname}${port}`

    // silent_redirect_uri: `${currentUri}/silent_refresh.html`,

    const oidcUserManagerConfig: UserManagerSettings = {
        client_id: config.clientId,
        redirect_uri: `${currentUri}/signin-oidc`,
        response_type: 'code',
        scope: config.scopes,
        post_logout_redirect_uri: currentUri,
        automaticSilentRenew: true,
        silent_redirect_uri: `${currentUri}/signin-oidc`,
        revokeTokensOnSignout: true, // log all the way out of STS?
        authority: config.stsUrl,
        // loadUserInfo: true,
    }
    userManager = new UserManager(oidcUserManagerConfig)
    return userManager
}